<div *ngIf="!isMobile">
  <table class="sc-grid__table">
    <caption hidden="true">{{summary}}</caption>
    <tr class="sc-grid__table__row-header">
      <th
        *ngFor="let head of settings.columns"
        scope="col"
        (click)="hanldeHeaderClick(head)"
        [attr.id]="'grid-header-' + head.id"
        class="sc-grid__table__row-header__head"
        [class.sc-grid__table__row-header__head--clickable]="head.sortable"
        [class.sc-grid__table__row-header__head--sorted]="head.id===gridSortBy.id"
        [ngClass]="head.columnClass"
      >
        {{head.header}}
        <sc-icon
          [icon]="getSortableColumnIcon(head)"
          class="sc-grid__table__row-header__head__arrow"
          *ngIf="head.sortable"
        ></sc-icon>
        <sc-tooltip 
          class="small sc-grid__table__row-header__head--help" 
          [description]="head.helpText" 
          [position]="head.helpTextPositionToolTip"
          *ngIf="head.helpText">
          <sc-icon 
            icon="alert-elipse-copy" 
            size="0_75">
          </sc-icon>
        </sc-tooltip>
      </th>
    </tr>
    <tbody *ngIf="!loading">
      <tr
        (click)="onRowClicked(row, rowIndex)"
        *ngFor="let row of items; let rowIndex= index"
        class="sc-grid__table__row"
        [ngClass]="settings.rowCustomClass && settings.rowCustomClass.call(null, row)">

        <td
          scope="row"
          *ngFor="let column of settings.columns;"
          [attr.id]="column.id + rowIndex"
          [class.sc-grid__table-cell--with-secondary]="column.hasSecondaryValue()"
          [ngClass]="column.columnClass"
          class="sc-grid__table-cell">

          <ng-container *ngIf="column.isValueColumn">
            <div class="cell__primary-text" [innerHtml]="column.getPrimaryValue(row)">
            </div>
            <div class="cell__secondary-text" [innerHtml]="column.getSecondaryValue(row)">
            </div>
          </ng-container>
          <!--actions-->
          <sc-context-menu
            *ngIf="column.isActionColumn && shouldShowContextMenu(column, row)"
            [items]="column.getActions(row)"
            [row]="row">
          </sc-context-menu>
          <sc-icon-context-menu *ngIf="column.isActionColumn && shouldshowIconContextMenu(column, row)"
          [row]="row"
          [icon]="column.getActions(row)[0]?.icon"
          [items]="column.getActions(row)"
          [tooltip]="column.getActions(row)[0]?.label">
          </sc-icon-context-menu>
          <!--actions-->
          <sc-cell-component-adapter
            *ngIf="column.isComponentColumn"
            [componentClass]="column.componentClass"
            [initializer]="column.initializer"
            [row]="row">
          </sc-cell-component-adapter>
        </td>
      </tr>
    </tbody>
    <tbody *ngIf="loading">
      <tr class="sc-grid__table__row timeline animated-background"
        *ngFor="let item of placeholderItems; let index = index;">
        <ng-container *ngTemplateOutlet="placeholderDesktopTemplate, context: { item: item, index: index }">
        </ng-container>
      </tr>
    </tbody>
    <tfoot *ngIf="hasFooter">
      <tr class="sc-grid__table__row">
        <td *ngFor="let column of settings.columns"
          [attr.id]="'grid-footer-' + column.id"
          class="sc-grid__table-cell sc-grid__table-cell__footer"
          [ngClass]="column.columnClass">

          <ng-container *ngIf="getFooter(column); let foot">
            <ng-container *ngIf="foot.isValueFooter">
              <div class="cell__primary-text">{{foot.getValue(items)}}</div>
            </ng-container>
            <sc-footer-component-adapter
              *ngIf="foot.isComponentFooter"
              [data]="foot.getValue(items)">
            </sc-footer-component-adapter>
          </ng-container>
        </td>
      </tr>
    </tfoot>
  </table>
</div>

<!-- Mobile-->
<div *ngIf="isMobile"
>
  <div *ngIf="!loading">
    <div
      class="sc-grid__card"
      *ngFor="let row of items; let rowIndex= index"
      [class.sc-grid__card--with-checkbox]="checkboxColumns.length > 0"
      [ngClass]="settings.rowCustomClass && settings.rowCustomClass.call(null, row)">
      <!-- Actions-->
      <div
        *ngIf="checkboxColumns.length > 0"
        class="sc-grid__card-checkboxes">
          <ng-container
        *ngFor="let column of checkboxColumns">
        <sc-cell-component-adapter
          class="sc-grid__card-checkbox"
          [componentClass]="column.componentClass"
          [initializer]="column.initializer"
          [row]="row">
        </sc-cell-component-adapter>
      </ng-container>
      </div>
      <!-- Actions-->
      <ng-container *ngFor="let column of actionColumns">
        <sc-context-menu
          *ngIf="column.getActions(row)?.length"
          class="sc-grid__card-menu"
          [ngClass]="column.columnClass"
          [items]="column.getActions(row)"
          [row]="row">
        </sc-context-menu>
      </ng-container>
      <!-- Auto generated cards-->
      <ng-container
        *ngIf="!settings.mobileCardComponentClass">
        <!-- Auto generated card fields-->
        <div class="sc-grid__card-fields"
             *ngFor="let column of otherColumns">
          <div
            class="sc-grid__card-field"
            [ngClass]="column.columnClass">
            <ng-container *ngIf="column.isValueColumn">
              <div class="cell__primary-text" [innerHtml]="column.getPrimaryValue(row)">
              </div>
            </ng-container>
            <sc-cell-component-adapter
              *ngIf="column.isComponentColumn"
              [componentClass]="column.componentClass"
              [initializer]="column.initializer"
              [row]="row"
              [index]="rowIndex" >
            </sc-cell-component-adapter>
          </div>
        </div>
      </ng-container>
      <!-- Custom Cards-->
      <ng-container
        *ngIf="settings.mobileCardComponentClass">
        <!-- Auto generated card context menu-->
        <sc-cell-component-adapter
          class="sc-grid__card-custom"
          *ngIf="settings.mobileCardComponentClass"
          [componentClass]="settings.mobileCardComponentClass"
          [row]="row">
        </sc-cell-component-adapter>
      </ng-container>
    </div>
    <div
      *ngIf="!!settings.mobileCardFooterComponentClass"
      class="sc-grid__card sc-grid__card__footer">
      <sc-footer-component-adapter
        *ngIf="settings.mobileCardFooterComponentClass"
        [data]="mobileCardFooterData">
      </sc-footer-component-adapter>
    </div
    >
  </div>
  <div *ngIf="loading">
    <!-- Auto generated loading -->
    <div class="sc-grid__card sc-grid__card__footer timeline animated-background"
      *ngFor="let item of placeholderItems; let index = index;">
      <ng-container *ngTemplateOutlet="placeholderMobileTemplate, context: { item: item, index: index }">
      </ng-container>
    </div>
  </div>
</div>

<div class="container">
  <sc-empty-table-message
    *ngIf="!loading && settings.emptyState && items && items.length === 0"
    [title]="settings.emptyState.title"
    [message]="settings.emptyState.message"
    [imageSrc]="settings.emptyState.imageSrc"
  >
  </sc-empty-table-message>
  <sc-empty-table-message
    *ngIf="!loading && settings.error && !items && hasError"
    [title]="settings.error.title"
    [message]="settings.error.message"
    (retry)="onLoadError()"
    [showButton]="!!settings.error.actionCallback"
    [imageSrc]="settings.error.imageSrc"
  >
  </sc-empty-table-message>
</div>

<ng-template #placeholderMobileTemplate>
    <div class="timeline-item-space"></div>
    <div *ngFor="let column of actionColumns">
      <div>
        <div class="timeline-item size-50"></div>
        <div class="timeline-item-space"></div>
      </div>
    </div>
    <div *ngFor="let column of otherColumns">
      <div class="timeline-item size-25"></div>
      <div class="timeline-item-space"></div>
    </div>
</ng-template>

<ng-template #placeholderDesktopTemplate>
  <td *ngFor="let column of settings.columns">
    <div *ngIf="column.isValueColumn">
      <div class="timeline-item-start"></div>
      <div class="timeline-item size-25"></div>
      <div class="timeline-item-space"></div>
      <div class="timeline-item size-50"></div>
      <div class="timeline-item-space"></div>
      <div class="timeline-item-end"></div>
    </div>
    <div *ngIf="column.isActionColumn">
      <div class="timeline-item-start"></div>
      <div class="timeline-item-space"></div>
      <div class="timeline-item size-25"></div>
      <div class="timeline-item size-25"></div>
      <div class="timeline-item-space"></div>
      <div class="timeline-item-end"></div>
    </div>
    <div *ngIf="column.isComponentColumn">
      <div class="timeline-item-start"></div>
      <div class="timeline-item-space"></div>
      <div class="timeline-item size-25"></div>
      <div class="timeline-item size-25"></div>
      <div class="timeline-item-space"></div>
      <div class="timeline-item-end"></div>
    </div>
  </td>
</ng-template>
